import React, {useEffect, useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';

const EventChildComponent = ({title, children}) => {
  return (
    <View style={{marginTop: 40}}>
      <Text
        style={[
          globalFontStyle.appFontHeading,
          styles.resolutionContainer,
          {color: Colors.tradexBlue},
        ]}>
        {title}
      </Text>
      <View style={{marginTop: 18}}>{children}</View>
    </View>
  );
};

export default EventChildComponent;

const styles = StyleSheet.create({
  resolutionContainer: {
    borderBottomWidth: 0.2,
    borderBottomColor: 'rgba(0, 0, 0, 0.5)',
    paddingBottom: 10,
  },
});
